// extracted by mini-css-extract-plugin
export default {"tooltip":"Map_tooltip__s6ild"};